module.exports = __webpack_public_path__ + "img/fid.e5805b22.png";